var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yujihua"},[_c('PublicCert',{attrs:{"logo":_vm.Logo1,"type":'acet',"color":'#f08608'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }